var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('v-card',{staticClass:"pa-10 text-center",attrs:{"light":"","rounded":"lg"}},[_vm._v(" "+_vm._s(_vm.getText())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }